// ヘッダーの高さを取得してその分コンテンツを下げる
$(function() {

    // ヘッダーの高さを取得
    const aside = $("aside").height();
    const height = $("header").outerHeight();
    const headerHeight = aside + height;
    // ヘッダーの高さ分コンテンツを下げる
    $("main").css("margin-top", - headerHeight);
    $("main").css("padding-top", headerHeight);
 
    // #で始まるa要素をクリックした場合の処理
    $('a[href^="#"]').click(function() {
      
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      if ($('aside').length) {
        var adjustAside = $('header').outerHeight() + $('aside').outerHeight() + 25;
        var positionAside = target.offset().top - adjustAside;
        $('body,html').animate({scrollTop: positionAside}, 500, 'swing');
        return false;
        
      } else {
        var adjustHeader = $('header').outerHeight() + 25;
        var positionHeader = target.offset().top - adjustHeader;
        $('body,html').animate({scrollTop: positionHeader}, 500, 'swing');
        return false;
        
      }
    });

    if(window.innerWidth < 768) {    //スマホ

      //ハンバーガーメニュー調整
      if($('body').hasClass('show-notification')){
        $("#nav").css("height", "calc(100% - 5.1rem)");
      }else{
        $("#nav").css("height", "calc(100% - 3rem)");
      }
    
      
    } else {      //PC

    }
 
 });

 //イベントページ
const filterButtons = document.querySelectorAll('[data-filter]');
const categoryContents = document.querySelectorAll('[data-category]');

filterButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', buttonSwitch);
  filterButton.addEventListener('click', categoryFilter);
});

function buttonSwitch() {
  filterButtons.forEach((filterButton) => {
    filterButton.classList.remove("is-active");
    this.classList.add('is-active');
  });
}

// イベントページ
function categoryFilter() {
  const buttonCategory = this.dataset.filter;
  const targetContents = document.querySelectorAll('[data-category="' + buttonCategory + '"]');

  categoryContents.forEach((categoryContent) => {

    categoryContent.animate([{
        opacity: 0
      },
      {
        opacity: 1
      }
    ], {
      duration: 600,
      fill: 'forwards'
    });

    if (buttonCategory == 'all') {
      categoryContent.classList.add('is-show');
    } else {
      categoryContent.classList.remove("is-show");
      targetContents.forEach((targetContent) => {
        targetContent.classList.add('is-show');
      });
    }
  });
}